import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PurchaseLimitError } from '@core/enums/purchase-limit-error.enum';
import { ModalConfig } from '@core/models/modal-config.model';
import { AppState } from '@core/store';
import { selectOrderLineById, selectPurchaseLimitRuleModal } from '@core/store/cart';
import { PurchaseLimitRuleModal } from '@core/store/cart/cart-state-models';
import { fetchCart, resetPurchaseLimitRuleModal } from '@core/store/cart/cart.actions';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-purchase-limit-warning-modal',
  templateUrl: './purchase-limit-warning-modal.component.html',
  styleUrls: ['./purchase-limit-warning-modal.component.scss'],
})
export class PurchaseLimitWarningModalComponent implements OnDestroy {
  @Input() isCartEmpty: boolean = false;
  @Input() isPaymentStep: boolean = false;
  @Output() okClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  readonly ModalType = PurchaseLimitError;

  purchaseLimitRule$: Observable<PurchaseLimitRuleModal>;
  alreadyInCartQty$: Observable<number>;
  quantityLimit$: Observable<number>;

  modalConfig: ModalConfig = {
    hideCloseButton: true,
    hideDismissButton: true,
    ngbModalOptions: {
      size: 'md',
    },
    onDismiss: this.dismiss.bind(this),
  };

  @ViewChild('modal') private modal: ModalComponent;

  private subscription: Subscription = new Subscription();

  constructor(
    private store$: Store<AppState>,
    private router: Router,
  ) {
    this.purchaseLimitRule$ = this.store$
      .select(selectPurchaseLimitRuleModal)
      .pipe(filter((rule) => !!rule?.data));

    this.subscription.add(
      this.purchaseLimitRule$.subscribe((rule) => {
        this.alreadyInCartQty$ = this.store$
          .select(selectOrderLineById(rule.data.orderLineId))
          .pipe(map((orderLine) => orderLine?.quantity ?? 0));

        this.quantityLimit$ = this.store$
          .select(selectOrderLineById(rule.data.orderLineId))
          .pipe(map((orderLine) => rule.product?.quantityLimit ?? orderLine?.quantityLimit ?? 0));

        this.modalConfig.title = rule.data.errorHeadline;

        this.modal?.open();
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close(): void {
    this.store$.dispatch(resetPurchaseLimitRuleModal());
    this.modal.close();
  }

  dismiss(): void {
    this.store$.dispatch(fetchCart());
    this.close();
  }

  ok(): void {
    if (this.isCartEmpty) {
      this.router.navigate(['/']);
    } else {
      this.okClicked.emit();
    }

    this.dismiss();
  }
}
